import {keyNotation} from './keyNotation.js';

export const Keyboard = {
  defineNodes: ['Keyboard', 'KeyboardKey'],
  parseInline: [{
    name: 'Keyboard',
    before: 'HTMLTag',
    parse(context, next, pos) {
      if (next === 60) { // code 60 is character <
        const editorString = context.slice(pos, Math.min(pos + 64, context.end));
        return parsedKeyboardNotation(context, pos, editorString);
      }
    }
  }]
};

export const keyboardRegex = /^<kbd>(\S+?)<\/kbd>/;

function parsedKeyboardNotation(context, pos, editorString) {
  const match = keyboardRegex.exec(editorString);
  if (match) {
    const [keyboardString, keyString] = match;
    return keyboardElement(context, keyboardString, keyString, pos, pos + 5);
  }
}

function keyboardElement(context, keyboardString, keyString, pos, contentOffset) {
  const notation = keyNotation(keyString);
  if (notation) {
    const keyboardKeys = notation.map(group => context.elt('KeyboardKey', contentOffset + group.start, contentOffset + group.end));
    return context.addElement(context.elt('Keyboard', pos, pos + keyboardString.length, keyboardKeys));
  }
}
